exports.GlobalVariables = {
  ACCESS_FIRST: 1,
  ID_STATUS_ATIVO: 1,
  ADM_QYON: "4",
  TIPO_PROMOTOR_CONSULTOR: "1",
  TIPO_PROMOTOR_FRANQUIA: "2",
  TIPO_PROMOTOR_CONTADOR: "3",
  TIPO_PROMOTOR_ENTIDADE: "4",

  ID_PROMOTOR_QYON: "42343243000199",
  ID_USUARIO_QYON_MASTER: 39,

  ID_FAMILIA_ERP: 1,
  ID_FAMILIA_PONTO: 5,
  ID_PRODUTO_ERP: 1,
  ID_VERSAO_ERP_PRO_ADICIONAL: 21,
  ID_VERSAO_ERP_GESTAO_FACIL: 23,
  ID_VERSAO_ERP_ADM_FACIL: 4,

  TIPO_PROMOTOR: {
    1: {
      Promoter: "IdPromotorConsultor",
      User: "IdUsuarioConsultor",
      Date: "DataConsultor",
    },
    2: {
      Promoter: "IdPromotorFranquia",
      User: "IdUsuarioFranquia",
      Date: "DataFranquia",
    },
    3: {
      Promoter: "IdPromotorContador",
      User: "IdUsuarioContador",
      Date: "DataContador",
    },
    4: {
      Promoter: "IdPromotorEntidade",
      User: "IdUsuarioEntidade",
      Date: "DataEntidade",
    },
  },

  REDIRECT_BLOCK: ["login", "integration", "liberarportal", "liberarbpo"],
  MAXIMUM_TRIAL_DATE_CHANGES: 2,
  CONTRACT_STATUS: [
    {
      status: "active",
      acronym: "A",
      description: "Ativo",
    },
    {
      status: "cancelled",
      acronym: "C",
      description: "Cancelado",
    },
    {
      status: "suspended",
      acronym: "S",
      description: "Susupenso",
    },
  ],

  SEGMENTS: {
    DEFAULT: 21,
  }
};
